/**
 * @author PoornaChandu
 * @description 
 */
import React , {useState,useEffect,useRef} from 'react';
import '../CSS/style.css';
import moment from 'moment';
import { connect } from 'react-redux';
import CommentsForm from './CommentsForm';
import { ANALYTICS, IPAddress } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { SubmitForm,
   getUserList,
 getRelatedTags,
  getStatusList } from '../APICalls/FormCalls';
 //import { getUserListData } from '../APICalls/FormCalls';
import {
  Form,
  Input,
  message,
  Button,
  Select,
  Popconfirm,
  Tabs,
  Upload,
  Tooltip,
  Badge,
  Drawer,
  Radio,
  DatePicker,
  Divider,
  Card,
  Space,
  Modal
} from 'antd';
import {
  PlusOutlined,
  QuestionCircleOutlined,
  UnorderedListOutlined,
  DeleteOutlined,
  UploadOutlined,
  CommentOutlined,
  UserOutlined,
  FieldTimeOutlined,
  DownloadOutlined,
  EditOutlined,
  CalendarOutlined,
  AppstoreOutlined
} from '@ant-design/icons';
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const PredictionForm = (props) => {
  const formHeader = useRef();
  const myRef = useRef();
  const analysisRef = useRef();
  const analysisresultRef = useRef();
  const predictionRef = useRef();
  const predictionResultRef = useRef();
  const [formObject, setFormObject] = useState(props.formObject && props.formObject ? props.formObject : {});
  const [useCaseModalVisible, setUseCaseModalVisible] = useState(false);
  const [predictionTaskModalVisible, setPredictionTaskModalVisible] = useState(false);
  const [remarksModalVisible, setRemarksModalVisible] = useState(false);
  const [users,setUsers] = useState([]);
  const [analysisTaskModalVisible, setAnalysisTaskModalVisible] = useState(false);
  const [relatedTags,setRelatedTags] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  //const [showdownloadModal, setShowDownloadModal] = useState(false);
  const [showusecasedownloadModal, setShowUseCaseDownloadModal] = useState(false);
  const [commentsData, setCommentsData] = useState({});
//  const [resultsCommentsData, setResultsCommentsData] = useState({});
  const [analysisfileModalVisible, setAnalysisFileModalVisible] = useState(false);
  const [predictionfileModalVisible, setPredictionFileModalVisible] = useState(false);
  const [analysisResultsFileModalVisible, setAnalysisResultsFileModalVisible] = useState(false);
  const [predictionResultsFileModalVisible, setPredictionResultsFileModalVisible] = useState(false);
  const [analysisTasksdataSource, setAnalysisTasksDataSource] = useState([]);
  const [predictiondataSource, setPredictionDataSource] = useState([]);
  const [analysisResultsdataSource, setAnalysisResultsDataSource] = useState([]);
  const [predictionResultsdataSource, setPredictionResultsDataSource] = useState([]);
  const [selectedTask, setSelectedTask] = useState(props.selectedTask || 'Analysis Tasks');
  const [statusList, setStatusList] = useState([]);
  const [activeKey, setActiveKey] = useState('1');
  const [viewType, setViewType] = useState('card');
  const [predictionViewType, setPredictionViewType] = useState('card');
  const [predictionActivekey, setPredictionActiveKey] = useState('1');
  //const [myId, setMyId] = useState('');
  const [myIndex, setMyIndex] = useState('');
 // const [visible, setVisible] = useState(true);
  const [AnalysisTasks, setAnalysisTasks] = useState([]);
  const [addanalyticData, setAddAnalyticData] = useState(false);
  const [addPredictionData, setAddPredictionData] = useState(false);
  const [isAanalyticResultVisible, setIsAnalyticResultVisible] = useState(false);
  const [predictionIndex, setPredictionIndex] = useState('');
 // const [predictionId, setPredictionId] = useState('');
  const [isPredictionResultVisible, setIsPredictionResultVisible] = useState(false);
  //let resultIndex = resId;
 // const [resultIndex, setResultIndex] = useState('');
  const [resultModalVisible, setResultModalVisible] = useState(false);
 const [predictionResult, setPredictionResult] = useState(false);
  //const [cardResultIndex, setCardResultIndex] = useState('');
  const [addNewResult, setAddNewResult] = useState(false);
  const [predictionResultInd, setPredictionResultInd] = useState('');
  const [addNewPredictionResult, setAddNewPredictionResult] = useState(false);
 // const [PredictionTasks, setPredictionTasks] = useState([]);
  //const [analyticTaskId, setAnalyticTaskId] = useState(0);
  const [predictionTaskId, setPredictionTaskId] = useState(0);
  const [anaLyticTableEdit, setAnalyticTableEdit] = useState(false);
  const [analyticTableId, setAnalyticTableId] = useState('');
  const [predictionTableId, setPredictionTableId] = useState('');
 // const [filterKey, setFilterKey] = useState(null);
 // const [searchField, setSearchField] = useState('');
 // const [userList, setUserList] = useState([]);
 // const [myData, setMyData] = useState(props.myData);
 
  useEffect(() => {
    const fetchData = async () => {
     const list = await getUserList();
     setUsers(list);
      const relatedTags = await getRelatedTags();
      setRelatedTags(relatedTags);
      const statusList = await getStatusList();
      setStatusList(statusList);
     // const userList = await getUserListData();
     // setUserList(userList);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (
      props.userProfile !== userProfile ||
      props.formObject !== formObject ||
      props.selectedTask !== selectedTask
    ) {
      formHeader.current.setFieldsValue(props.formObject);
      setUserProfile(props.userProfile);
      setFormObject(props.formObject);
      setSelectedTask(props.selectedTask);
    }
    setSelectedTask('Analysis Tasks');
    formHeader.current.setFieldsValue({
      CreatedBy: props.userProfile?.user?.Id,
      CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss')
    });
  }, [props.userProfile, props.formObject, props.selectedTask]);
  const onReset = () => {
    formHeader.current.resetFields();
  };
  const onFinish = async () => {
    const data = formHeader.current.getFieldsValue();
    const currentFormObject = formObject;
    try {
      await formHeader.current.validateFields();
      const payload = {
        ...currentFormObject,
        Title: data.Title,
        relatedTags: data.relatedTags,
        Usecase: data.Usecase,
        functionalDescription: data.functionalDescription,
        CreatedBy: props.userProfile?.user?.Id,
        CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss')
      };
      // this.formHeader.current.setFieldsValue(payload);
      const urlList = {
        insert: `${ANALYTICS.CREATE}`,
        update: `${ANALYTICS.UPDATE}`
      };
      let statusResponse={};
      if (currentFormObject?.Id) {
        statusResponse = await SubmitForm(payload, urlList.update);
      } else {
        statusResponse = await SubmitForm(payload, urlList.insert);
      }
      if (statusResponse?.message) {
        props._getAdhocDataSource();
        message.success(statusResponse.message);
        onReset();
      } else if (statusResponse?.Error) {
        message.error(statusResponse.Error);
      } else {
        message.error('Error');
      }
    } catch (error) {
      console.log(error);
    }
  };
  const onFinishFailed = () => {
    message.error('Please Provide mandatory fields');
  };
  const useCaseModalClose = () => {
    setUseCaseModalVisible(false);
  };
  const analysisTaskModalClose = () => {
    setAnalysisTaskModalVisible(false);
  };
  // onhandleChange = (e) => {
  //   const {  userList,formObject ,myData } = this.state;
  //   this.setState({ filterKey: e });
  //   if (e === 'Assigne') {
  //     const newArray = myData.AnalysisTasks.map((obj1) => {
  //       const obj2 = userList.find((obj2) => obj2.Id === obj1.Assigne);
  //       return {
  //         ...obj1,
  //         FirstName: obj2.FirstName
  //       };
  //     });
  //     this.setState({ formObject:{...formObject,AnalysisTasks:newArray} });
  //   }
  // };
  // filterByValue = (value) => {
  //   let { formObject, filterKey,myData } = this.state;
  //   let SearchedDate = null;
  //   const formats = ['DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD'];
  //   if (filterKey === 'Assigne') {
  //     return myData.AnalysisTasks.filter((o) => {
  //       return o.FirstName.toString().toLowerCase().includes(value.toString().toLowerCase());
  //     });
  //   }else if (filterKey === 'CreatedDate') {
  //     for (const format of formats) {
  //       const momentObj = moment(value, format, true);
  //       if (momentObj.isValid()) {
  //         SearchedDate = momentObj.toDate();
  //         break;
  //       }
  //     }
  //     if (SearchedDate !== null) {
  //       const cretaeddate = myData.AnalysisTasks.filter((o) => {
  //         const date = new Date(o.CreatedDate);
  //         return (
  //           date.getDate() === SearchedDate.getDate() &&
  //           date.getMonth() === SearchedDate.getMonth() &&
  //           date.getFullYear() === SearchedDate.getFullYear()
  //         );
  //      });
  //       return cretaeddate;
  //     }
  //   } else {
  //     return myData.AnalysisTasks.filter((o) => {
  //       return o[filterKey].toString().toLowerCase().includes(value.toString().toLowerCase());
  //     });
  //   }
  // };
  // onSearch = () => {
  //   const {searchField,formObject} = this.state;
  //   let dataSource = this.filterByValue(searchField);
  //   this.setState({formObject:{...formObject,AnalysisTasks:dataSource}  });
  // };
  const predictionTaskModalClose = () => {
    setPredictionTaskModalVisible(false);
  };
  const resultsModalClose = () => {
    setRemarksModalVisible(false);
  };
  const SubmitComments = (value, key, index, mainKey, mainIndex) => {
    if (
      formObject[mainKey]?.[mainIndex]?.[key]?.[index]
    ) {
      if (formObject[mainKey][mainIndex][key][index]['Comments']) {
        formObject[mainKey][mainIndex][key][index]['Comments'].push(
          ...value.filter((item) => item.Id === undefined)
        );
        formObject[mainKey][mainIndex][key][index]['Comments'] = formObject[mainKey][mainIndex][key][index]['Comments'].filter((obj, Index) => {
          return (
            Index ===
            formObject[mainKey][mainIndex][key][index]['Comments'].findIndex(
              (o) => obj.Comment === o.Comment
            )
          );
        });
      } else {
        formObject[mainKey][mainIndex][key][index]['Comments'] = value;
      }
    } else if (formObject[key]?.[index]) {
      if (formObject[key][index]['Comments']) {
        formObject[key][index]['Comments'].push(
          ...value.filter((item) => item.Id === undefined)
        );
        formObject[key][index]['Comments'] = formObject[key][index]['Comments'].filter(
          (obj, Index) => {
            return (
              Index ===
              formObject[key][index]['Comments'].findIndex((o) => obj.Comment === o.Comment)
            );
          }
        );
      } else {
        formObject[key][index]['Comments'] = value;
      }
    } else {
      if (formObject['Comments']) {
        formObject['Comments'].push(
          ...value.filter((item) => item.Id === undefined)
        );
        formObject['Comments'] = formObject['Comments'].filter((obj, Index) => {
          return Index === formObject['Comments'].findIndex((o) => obj.Comment === o.Comment);
        });
      } else {
        formObject['Comments'] = value;
      }
    }
    setFormObject(formObject);
    setUseCaseModalVisible(false);
    setAnalysisTaskModalVisible(false);
    setPredictionTaskModalVisible(false);
    setRemarksModalVisible(false);
    formHeader.current.setFieldsValue(formObject);
  };
  const onViewTypeChange = (type, viewType) => {
    if (type === 'Analysis Tasks') {
      setViewType(viewType);
    } else if (type === 'Prediction Tasks') {
      setPredictionViewType(viewType);
    }
  };
  const fileUpload = (info, key, index, mainKey, mainIndex) => {
    if (info.file.status === 'done') {
      const id = info.file.response?.Id;
      const Name = info.file.response?.Name;
      if (formObject[mainKey]?.[mainIndex]?.[key]?.[index]) {
        if (formObject[mainKey][mainIndex][key][index]['Attachments']) {
          formObject[mainKey][mainIndex][key][index]['Attachments'] = formObject[mainKey][mainIndex][key][index]['Attachments'] || [];
          formObject[mainKey][mainIndex][key][index]['Attachments'].push({
            Id: id,
            file: Name
          });
        } else {
          formObject[mainKey][mainIndex][key][index]['Attachments'] = [{
            Id: id,
            file: Name
          }];
        }
      } else if (formObject[key]?.[index]) {
        if (formObject[key][index]['Attachments']) {
          formObject[key][index]['Attachments'] = formObject[key][index]['Attachments'] || [];
          formObject[key][index]['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject[key][index]['Attachments'] = [{ Id: id, file: Name }];
        }
      } else {
        if (formObject['Attachments']) {
          formObject['Attachments'] = formObject['Attachments'] || [];
          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject['Attachments'] = [{ Id: id, file: Name }];
        }
      }
      setFormObject(formObject);
      formHeader.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const handleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current.click();
    } else {
      setShowUseCaseDownloadModal(true);
    }
  };
  const handleAnalysisTasksClick = (e, key) => {

    if (e === 'Add New Attachments') {
      analysisRef.current.click();
    } else {
      setAnalysisFileModalVisible(true);
      setAnalysisTasksDataSource(
        formObject['AnalysisTasks']?.[key]?.Attachments || []
      );
    }
  };
  const handlePredictionTasksClick = (e, key) => {
    if (e === 'Add New Attachments') {
      predictionRef.current.click();
    } else {
      setPredictionFileModalVisible(true);
      setPredictionDataSource(
        formObject['PredictionTasks']?.[key]?.Attachments || []
      );
    }
  };
  const handleAnalysisResultsClick = (e, key, index2) => {
 
    if (e === 'Add New Attachments') {
      analysisresultRef.current.click();
    } else {
      setAnalysisResultsFileModalVisible(true);
      setAnalysisResultsDataSource(
        formObject['AnalysisTasks']?.[key]?.Results?.[index2]?.Attachments || []
      );
    }
  };
  const handlePredictionResultsClick = (e, key, index2) => {
    if (e === 'Add New Attachments') {
      predictionResultRef.current.click();
    } else {
      setPredictionResultsFileModalVisible(true);
      setPredictionResultsDataSource(
        formObject?.PredictionTasks?.[key]?.Results?.[index2]?.Attachments || []
      );
    }
  };
  const add3Dots = (text, limit) => {
    const dots = '...';
    return text.length > limit ? text.substring(0, limit) + dots : text;
  };
  // const onChange = (value) => {
  //   setSelectedDate({
  //     startDate: moment(value[0]).format('YYYY-MM-DD HH:mm'),
  //     endDate: moment(value[1]).format('YYYY-MM-DD HH:mm')
  //   });
  // };
  const editAnalyticTaskData = (data, id, i) => {
    setActiveKey('2');
   // setMyId(id);
    setMyIndex(i);
   // setVisible(false);
    setAddAnalyticData(false);
    setResultModalVisible(true);
  };
  const editPredictionData = (data, id, i) => {
    setActiveKey('2');
   // setPredictionId(id);
    setPredictionIndex(i);
    setAddPredictionData(false);
    setPredictionResult(true);
  };
  const deletePredictionTasks = (index, id) => {
    let { isEditable } = props;
    let array = formObject.PredictionTasks;
    if (isEditable !== 'new') {
      array.splice(id, 1);
      const FormObject = { ...formObject, PredictionTasks: array };
      setFormObject(FormObject);

    } else {
      let newarray = formObject.PredictionTasks.filter((item, i) => i !== index);
       const FormObject = { ...formObject, PredictionTasks: newarray };
      setFormObject(FormObject);      
    }
  };
  const deleteAnalyticTable = (id) => {
    const arr = formObject.AnalysisTasks;
    const objWithIdIndex = arr.findIndex((obj) => obj.id === id);
    arr.splice(objWithIdIndex, 1);
    const FormObject = { ...formObject, AnalysisTasks: arr };
    setFormObject(FormObject);
  };
  const deletePredictionTable = (id) => {
    const arr = formObject.PredictionTasks;
    const objWithIdIndex = arr.findIndex((obj) => obj.id === id);
    arr.splice(objWithIdIndex, 1);
    let Formobject = { ...formObject, PredictionTasks: arr };
    setFormObject(Formobject);
  };
  const deleteAnalyticTask = (index, id) => {
    const array = formObject.AnalysisTasks;
    const { isEditable } = props;
    if (isEditable !== 'new') {
      array.splice(id, 1);
      let Formobject =  { ...formObject, AnalysisTasks: array };  
      setFormObject(Formobject);
    } else {
      const newarray = formObject.AnalysisTasks.filter((item, i) => i !== index);
      let FormObject = { ...formObject, AnalysisTasks: newarray };
      setFormObject(FormObject);
    }
  };
  const deleteResultTasks = (mainKey, mainIndex, key, index) => {
    if (mainKey === 'AnalysisTasks') {
      const newArray = formObject[mainKey][mainIndex].Results.filter((item, i) => i !== index);
       const FormObject = {
        ...formObject,
        AnalysisTasks: [{ ...formObject, Results: newArray }]
       };
       setFormObject(FormObject);
    } else if (mainKey === 'PredictionTasks') {
      const newArray = formObject[mainKey][mainIndex].Results.filter((item, i) => i !== index);
      const FormObject = {
        ...formObject,
          PredictionTasks: [{ ...formObject, Results: newArray }]
       } ;
       setFormObject(FormObject);
    }
  };
  const editAnalyticTable = (id) => {
    setActiveKey('2');
    setAnalyticTableEdit(true);
    setAnalyticTableId(id);
  };
  const editPredictionable = (id) => {
    setActiveKey('2');
    setPredictionTableId(id);
  };
  const editAnalyticResult = (item, itemId, resInd, key) => {
    if (key === 'PredictionTasks') {
      setIsPredictionResultVisible(true);
      setPredictionResultInd(resInd);
    } else if (key === 'AnalysisTasks') {
      setIsAnalyticResultVisible(true);
      //setResultIndex(resInd);
    }
  };
  // const handleChange = (value, index, key) => {
  //   const updatedTasks = formObject.AnalysisTasks.map((item, colIndex) => {
  //     if (colIndex === index) {
  //       return { ...item, [key]: value };
  //     }
  //     return item;
  //   });
  //   setFormObject({ ...formObject, AnalysisTasks: updatedTasks });
  // };
  const addPredictions = () => {
    const { isEditable } = props;
    const obj = {
      Title: '',
      functionalDescription: '',
      relatedTags: '',
      CreatedBy: props.userProfile?.user?.Id,
      CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      Assigne: '',
      Comments: [],
      Attachments: [],
      Results: []
    };
    if (isEditable !== 'new') {
      formObject && formObject.PredictionTasks && formObject.PredictionTasks.push(obj);
      setFormObject(formObject);
      setPredictionActiveKey('2');
      setPredictionTaskId(predictionTaskId+1);
      setAddPredictionData(true);
      // setPrediction(false);
    } else {
      const  formObject = formHeader.current.getFieldsValue();
      let PredictionTasks = [];
      formObject['PredictionTasks'] = [];
      setFormObject(formObject);
      PredictionTasks.push(obj);
      let FormObject = {
        ...formObject,
        PredictionTasks: PredictionTasks
      };
      setFormObject(FormObject);
      setPredictionActiveKey('2');
      setAddPredictionData(true);
      // setPrediction(false);

    }
  };
  const addAnalytics = () => {
    const { isEditable } = props;
    const obj = {
      Title: '',
      functionalDescription: '',
      relatedTags: '',
      CreatedBy: props.userProfile?.user?.Id,
      CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      Assigne: '',
      Comments: [],
      Attachments: [],
      Results: []
    };
    if (isEditable !== 'new') {
      formObject && formObject.AnalysisTasks && Array.isArray(formObject.AnalysisTasks) && formObject.AnalysisTasks.push(obj);
      setFormObject(formObject);
      setActiveKey('2');
      setAddAnalyticData(true);
    } else {
      let formObject = formHeader.current.getFieldsValue();
      formObject['AnalysisTasks'] = [];
      setFormObject(formObject);
      AnalysisTasks.push(obj);
      const  FormObject = {
        ...formObject,
        AnalysisTasks: AnalysisTasks
      };
      setActiveKey('2');
      setFormObject(FormObject);
      setAddAnalyticData(true);
      setAnalysisTasks(AnalysisTasks);
    }
  };
  const addResultAnalytics = (analyticIndex) => {
    if (!formObject.AnalysisTasks[analyticIndex].Results) {
      formObject.AnalysisTasks[analyticIndex]['Results'] = [];
    }
    const resultObject = {
      Description: '',
      Comments: [],
      Attachments: [],
      CreatedBy: props.userProfile?.user?.Id,
      CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss')
    };
    formObject.AnalysisTasks[analyticIndex].Results.push(resultObject);
    setFormObject(formObject );
    setIsAnalyticResultVisible(true);
    setResultModalVisible(false);
    setAddNewResult(true);
  };
  const addPredictionResults = (predictionId) => {
    if (!formObject.PredictionTasks[predictionId].Results) {
      formObject.PredictionTasks[predictionId]['Results'] = [];
    }
    const resultObject = {
      Description: '',
      CreatedBy: props.userProfile?.user?.Id,
      CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      Comments: [],
      Attachments: []
    };
    formObject.PredictionTasks[predictionId].Results.push(resultObject);
    setFormObject(formObject );
    setIsPredictionResultVisible(true);
    setPredictionResult(false);
    setAddNewPredictionResult(true);
  };
  const handleOk = () => {
    setIsAnalyticResultVisible(false);
    setResultModalVisible(true);
    setAddNewResult(false);
    setFormObject(formObject);
  };
  const handleOkPrediction = () => {
    setIsPredictionResultVisible(false);
    setPredictionResult(true);
    setAddNewPredictionResult(false);
  };
  const handleCancelPrediction = () => {
    setIsPredictionResultVisible(false);
    setAddNewPredictionResult(true);
  };
  const handleCancel = () => {
    setIsAnalyticResultVisible(false);
    setAddNewResult(true);
  };
  // const onPrediction = (e) => {
  //   setFormObject((prev) => ({ prev, selectedTask: e.target.value }));
  // };
  const onResultTaskHandleChange = (value, mainKey, mainIndex, resultKey, resultIndex, key) => {
    
    formObject[mainKey][mainIndex][resultKey][resultIndex][key] = value;
    setFormObject(formObject);

    
  };
  const onHandleChangeAnalysis = (value, TaskKey, index, key) => {
    
    formObject[TaskKey][index][key] = value;
    setFormObject(formObject);
  };
  const disabledDate = (current) => {
    return current > moment().startOf('day').add(1, 'day');
  };
  const onHandleChangePrediction = (value, TaskKey, index, key) => {
    
    formObject[TaskKey][index][key] = value;
    if (key === 'Date') {
      let FormObject = {
        ...formObject,
        [TaskKey] :[
          ...formObject[TaskKey],
          // {
          // Date: [
          //   moment(value[0]).format('YYYY-MM-DD HH:mm'),
          //   moment(value[1]).format('YYYY-MM-DD HH:mm')
          ]
        // }
        
      };
      setFormObject(FormObject);
    } else {
      setFormObject(formObject);
    }
     
  };
    const IconText = ({ icon, text }) => (
      <Space>
        {React.createElement(icon)}
        {text}
      </Space>
    );
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    let userName =
      props &&
      props.userProfile &&
      props.userProfile.user &&
      props.userProfile.user.Id;
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const columns = [
    {
      title: 'File',
      dataIndex: 'file',
      key: 'file',
      align: 'center',
    },
    {
      title: 'Action',
      width: '600',
      align: 'center',
      render: (text, record) => (
        <Tooltip placement="top" title="Download">
          <div style={{ marginLeft: '-25px' }}>
            <a href={`${IPAddress.LOCAL}/api/IOTAAttachments/${record.file}`}>
            {' '}              
            <DownloadOutlined style={{ color: '#1a91ff' }} />
            </a>
          </div>
        </Tooltip>
      ),
    },
  ];
  const AnalyticsColumns = [
    {
      title: 'Title',
      dataIndex: 'Title',
      key: 'Title',
      align: 'center',
      width: '20%',
    },
    {
      title: 'Functional Description',
      dataIndex: 'functionalDescription',
      key: 'functionalDescription',
      align: 'center',
      width: '60%',
    },
    {
      title: 'Action',
      align: 'center',
      width: '20%',
      render: (text, record) => (
        <>
          <Button onClick={() => editAnalyticTable(record.Id, record)} >
            <EditOutlined />
          </Button>
          <Popconfirm
            title="Are you sure that you want to delete the Task"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteAnalyticTable(record.Id)}
            okText="Yes"
            cancelText="No"
          >
            <Button  style={{ marginLeft: '20px' }}>
              <span style={{ color: '#ff4d4f' }}>
                <DeleteOutlined />
              </span>
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];
  const PredictionColumns = [
    {
      title: 'Title',
      dataIndex: 'Title',
      key: 'Title',
      align: 'center',
      width: '20%',
    },
    {
      title: 'Functional Description',
      dataIndex: 'functionalDescription',
      key: 'functionalDescription',
      align: 'center',
      width: '60%',
    },
    {
      title: 'Action',
      align: 'center',
      width: '20%',
      render: (text, record) => (
        <>
          <Button onClick={() => editPredictionable(record.Id, record)} >
            <EditOutlined />
          </Button>
          <Popconfirm
            title="Are you sure that you want to delete the Task"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deletePredictionTable(record.Id)}
            okText="Yes"
            cancelText="No"
          >
            <Button  style={{ marginLeft: '20px' }}>
              <span style={{ color: '#ff4d4f' }}>
                <DeleteOutlined />
              </span>
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];
  
  const items01 = [
    {
      key: '1',
      label: 'List of Analytics',
      children: (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {activeKey === '1' && viewType === 'card' ? (
            formObject?.Id && formObject?.AnalysisTasks ? (
              formObject.AnalysisTasks.map((item, i) => (
                <Card key={item.title} style={{ width: '410px', padding: '5px', margin: '5px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ padding: '0px 0px 6px 0px',  fontWeight: 'bolder', color: '#d98e04' }}>
                      {add3Dots(item.functionalDescription, 35)}
                    </div>
                    <div style={{ margin: '0px 0px 7px 0px' }}>
                      <IconText
                        icon={UserOutlined}
                        key="list-vertical-star-o"
                        text={props.userProfile?.user?.FirstName}
                      />
                    </div>
                    <div style={{ margin: '0px 0px 7px 0px' }}>
                      <IconText
                        icon={CalendarOutlined}
                        key="list-vertical-like-o"
                        text={moment(item.CreatedDate).format('DD-MM-YYYY HH:mm:ss')}
                      />
                    </div>
                  </div>
                  <Divider className="customDividerHor" style={{ borderTop: '1px solid #000', height: '0px' }} />
                  <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px' }}>
                    <Tooltip placement="top" title="Edit">
                      <EditOutlined
                        style={{ color: '#d98e04', marginRight: '8px' }}
                        onClick={() => editAnalyticTaskData(item, item.Id, i)}
                      />
                    </Tooltip>
                    <Divider type="vertical" />
                    <Popconfirm
                      title="Are you sure that you want to delete the Task"
                      icon={<QuestionCircleOutlined style={{ color: '#d98e04' }} />}
                      onConfirm={() => deleteAnalyticTask(item.Id, i)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Tooltip placement="top" title="Delete">
                        <DeleteOutlined style={{ color: '#d98e04', marginRight: '8px' }} />
                      </Tooltip>
                    </Popconfirm>
                  </div>
                </Card>
              ))
            ) : null
          ) : (
            <StyledTable size="small"
              className='table'
              dataSource={
                formObject &&
                  formObject.AnalysisTasks &&
                  Array.isArray(formObject.AnalysisTasks)
                  ? formObject.AnalysisTasks
                  : []
              }
              columns={AnalyticsColumns}
            />
          )}
        </div>
      ),
    },
    
    {
      key: '2',
      label: 'Details of Analytics',
      children: (
        <div>
         {formObject && Array.isArray(formObject.AnalysisTasks) ? (
          formObject.AnalysisTasks.map((item,index) => (
            <>
              {(myIndex === index || (formObject.AnalysisTasks[formObject.AnalysisTasks.length - 1] && addanalyticData === true) || (anaLyticTableEdit === true && analyticTableId === formObject.AnalysisTasks[index].Id)) ? (
                <div className="DetailsOfAnalyticsForm" style={{ display: 'flex', flexWrap: 'wrap', color: 'black' }} key={index}>
                  <Form.Item
                    name={['AnalysisTasks', index, 'Title']}
                    labelCol={{ flex: '130px' }}
                    label="Title"
                    style={{ flex: '100%' }}
                    onChange={(e) => onHandleChangeAnalysis(e.target.value, 'AnalysisTasks', index, 'Title')}
                    rules={[{ required: true, message: 'Please Provide Title' }]}
                  >
                    <Input maxLength={10000}  style={{ width: '50%' }} placeholder="Input Title" />
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'functionalDescription']}
                    labelCol={{ flex: '130px' }}
                    onChange={(e) => onHandleChangeAnalysis(e.target.value, 'AnalysisTasks', index, 'functionalDescription')}
                    label="Functional Description"
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Provide FunctionalDescription' }]}
                  >
                    <TextArea maxLength={10000} style={{ height: 100, width: '50%' }} placeholder="Input FunctionalDescription" />
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'relatedTags']}
                    labelCol={{ flex: '130px' }}
                    style={{ flex: '100%' }}
                    label="relatedTags"
                    rules={[{ required: true, message: 'relatedTags is required' }]}
                  >
                    <Select
                      style={{ width: '50%' }}
                      
                      mode="multiple"
                      onChange={(e) => onHandleChangeAnalysis(e, 'AnalysisTasks', index, 'RelatedTags')}
                      placeholder="Select Tags"
                    >
                      {relatedTags &&
                          Array.isArray(relatedTags) &&relatedTags.map((item, index) => (
                        <Select.Option key={index} value={item.Value}>
                          {item.Key}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'CreatedBy']}
                    labelCol={{ flex: '130px' }}
                    style={{ flex: '100%' }}
                    label="CreatedBy"
                    rules={[{ required: false, message: 'CreatedBy is required' }]}
                  >
                    <Select
                      disabled
                      
                      placeholder="Select CreatedBy"
                      value={props.userProfile?.user?.Id}
                      style={{ width: '50%' }}
                      onChange={(e) => onHandleChangeAnalysis(e, 'AnalysisTasks', index, 'CreatedBy')}
                    >
                      {users &&
                          Array.isArray(users) &&users.map((item) => (
                        <Select.Option key={item.Id} value={item.Id}>
                          {item.FirstName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'CreatedDate']}
                    labelCol={{ flex: '130px' }}
                    onChange={(e) => onHandleChangeAnalysis(e.target.value, 'AnalysisTasks', index, 'CreatedDate')}
                    label="CreatedDate"
                    style={{ flex: '100%' }}
                    rules={[{ required: false, message: 'Date is required' }]}
                  >
                    <Input
                      disabled
                      value={moment().format('YYYY-MM-DD HH:mm:ss')}
                      
                      style={{ width: '50%' }}
                      placeholder="CreatedDate"
                      suffix={<FieldTimeOutlined />}
                    />
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'Assigne']}
                    labelCol={{ flex: '130px' }}
                    label="Assigne"
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Select Assigne!' }]}
                  >
                    <Select
                      
                      placeholder="Select Assigne"
                      onChange={(e) => onHandleChangeAnalysis(e, 'AnalysisTasks', index, 'Assigne')}
                      style={{ width: '50%' }}
                    >
                      {users &&
                          Array.isArray(users) &&users.map((item) => (
                        <Select.Option key={item.Id} value={item.Id}>
                          {item.FirstName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'Status']}
                    labelCol={{ flex: '130px' }}
                    style={{ flex: '100%' }}
                    label="Status"
                    rules={[{ required: false, message: 'Please Select Status!' }]}
                  >
                    <Select
                      
                      style={{ width: '50%' }}
                      onChange={(e) => onHandleChangeAnalysis(e, 'AnalysisTasks', index, 'Status')}
                      placeholder="Select Status"
                    >
                      {statusList &&
                          Array.isArray(statusList) &&statusList.map((item, index) => (
                        <Select.Option key={index} value={item.Value}>
                          {item.Key}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'Date']}
                    labelCol={{ flex: '130px' }}
                    label="From And To Date"
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Provide Date' }]}
                  >
                    <RangePicker
                      value={
                        formObject &&
                            formObject.AnalysisTasks &&
                            formObject.AnalysisTasks[index] &&
                            formObject.AnalysisTasks[index].Date &&
                            formObject.AnalysisTasks[index].Date !== null
                          ? [
                              moment(formObject.AnalysisTasks[index].Date[0], dateFormat),
                              moment(formObject.AnalysisTasks[index].Date[1], dateFormat),
                            ]
                          : []
                      }
                      onChange={(e) => onHandleChangePrediction(e, 'AnalysisTasks', index, 'Date')}
                      disabledDate={(e) => disabledDate(e)}
                      style={{ width: '50%' }}
                      showTime={{ format: 'HH:mm' }}
                      format="YYYY-MM-DD HH:mm"
                    />
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'Approach']}
                    label="Approach"
                    labelCol={{ flex: '130px' }}
                    style={{ flex: '100%' }}
                    onChange={(e) => onHandleChangeAnalysis(e.target.value, 'AnalysisTasks', index, 'Approach')}
                    rules={[{ required: true, message: 'Please Provide Approach' }]}
                  >
                    <Input maxLength={10000}  style={{ width: '50%' }} placeholder="Input Approach" />
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'Algorithms']}
                    label="Algorithms"
                    onChange={(e) => onHandleChangeAnalysis(e.target.value, 'AnalysisTasks', index, 'Algorithms')}
                    labelCol={{ flex: '130px' }}
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Provide Algorithms' }]}
                  >
                    <Input maxLength={10000}  style={{ width: '50%' }} placeholder="Input Algorithms" />
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'Attachments']}
                    labelCol={{ flex: '130px' }}
                    style={{ flex: '100%' }}
                    label="Attachments"
                  >
                    <div>
                      <Select
                        
                        style={{ width: '50%' }}
                        placeholder={'Add/View Attachments'}
                        onChange={(e) => handleAnalysisTasksClick(e, index)}
                      >
                        <Select.Option key={'View Attachments'} value={'View Attachments'}>
                          View Attachments
                        </Select.Option>
                        <Select.Option key={'Add New Attachments'} value={'Add New Attachments'}>
                          Add New Attachments
                        </Select.Option>
                      </Select>
                      <Upload
                        multiple={true}
                        onChange={(info) => fileUpload(info, 'AnalysisTasks', index)}
                        action={`${ANALYTICS.FileUpload}?SiteId=${siteId}&Type=${'Task'}`}
                        headers={{ Authorization: Authorization }}
                        showUploadList={false}
                      >
                        <Button style={{ display: 'none' }} ref={analysisRef} className="uploadFile">
                          <UploadOutlined /> Upload
                        </Button>
                      </Upload>
                      <Drawer
                        title="AnalysisTask Uploaded Files"
                        open={analysisfileModalVisible}
                        width={600}
                        onOk={() => setAnalysisFileModalVisible(false)}
                        onClose={() => setAnalysisFileModalVisible(false)}
                      >
                        <StyledTable size="small"
                          className='table'
                          columns={columns}
                          dataSource={analysisTasksdataSource}
                        />
                      </Drawer>
                    </div>
                  </Form.Item>
                  <Form.Item
                    name={['AnalysisTasks', index, 'Comments']}
                    labelCol={{ flex: '130px' }}
                    style={{ flex: '100%' }}
                    label="Comments"
                  >
                    <Tooltip placement="topLeft" color={'red'} title="Click Here To Add Your Comments">
                      <Badge
                        count={formObject['AnalysisTasks']?.[index]?.Comments?.length}
                      >
                        <Button
                          style={{ background: '#eabe6f', color: 'black' }}
                          onClick={() => {
                            let commentsData = {
                              Comments: formObject['AnalysisTasks']?.[index]?.Comments || [],
                              index: index,
                            };
                            setCommentsData(commentsData);
                            // setRemarksModalVisible(true);
                            setAnalysisTaskModalVisible(true);
                          }}
                        >
                          <CommentOutlined />
                          Add/View Comments
                        </Button>
                      </Badge>
                    </Tooltip>
                  </Form.Item>
                  <Button
                    style={{ background: '#29415a', color: '#fff' }}
                    onClick={() => addResultAnalytics(index)}
                  >
                    <PlusOutlined /> Add Results
                  </Button>
                  <div style={{ marginTop: '60px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                      {formObject &&
                          formObject.AnalysisTasks &&
                          formObject.AnalysisTasks[index] &&
                          formObject.AnalysisTasks[index].Results &&
                          resultModalVisible === true
                          ? formObject.AnalysisTasks[index].Results.map((item, resultIndex) => {return(
                        <Card key={item.title} style={{ width: '410px', padding: '5px', margin: '5px' }}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ padding: '0px 0px 6px 0px',  fontWeight: 'bolder', color: '#d98e04' }}>
                              {add3Dots(item.Description, 35)}
                            </div>
                            <div style={{ margin: '0px 0px 7px 0px' }}>
                              <IconText
                                icon={UserOutlined}
                                text={props.userProfile?.user?.FirstName}
                              />
                            </div>
                            <div style={{ margin: '0px 0px 7px 0px' }}>
                              <IconText
                                icon={CalendarOutlined}
                                text={moment(item.CreatedDate).format('DD-MM-YYYY HH:mm:ss')}
                              />
                            </div>
                          </div>
                          <Divider className="customDividerHor" style={{ borderTop: '1px solid #000', height: '0px' }} />
                          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px' }}>
                            <Tooltip placement="top" title="Edit">
                              <EditOutlined
                                style={{ color: '#d98e04', marginRight: '8px' }}
                                onClick={() => editAnalyticResult(item, item.Id, resultIndex, 'AnalysisTasks')}
                              />
                            </Tooltip>
                            <Divider type="vertical" />
                            <Popconfirm
                              title="Are you sure that you want to delete the Result"
                              icon={<QuestionCircleOutlined style={{ color: '#d98e04' }} />}
                              onConfirm={() => deleteResultTasks('AnalysisTasks', index, 'Results', resultIndex)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Tooltip placement="top" title="Delete">
                                <DeleteOutlined style={{ color: '#d98e04', marginRight: '8px' }} />
                              </Tooltip>
                            </Popconfirm>
                          </div>
                        </Card>
                      );
                    }
                  ): null}
                  
                    </div>

                  </div>
                  {formObject &&
                      formObject.AnalysisTasks &&
                      formObject.AnalysisTasks[index] &&
                      formObject.AnalysisTasks[index].Results !== undefined &&
                      formObject.AnalysisTasks[index].Results.map(
                        (resultKey, resultIndex) => (
                          <>
                            {resultIndex === resultIndex || addNewResult === true ? (
                              <Modal
                                title="Add Result"
                                className="AddResultDrawer"
                                open={isAanalyticResultVisible}
                                onOk={handleOk}
                                onCancel={handleCancel}
                              >
                                <CommentsForm
                                  visible={remarksModalVisible}
                                  modalClose={resultsModalClose}
                                  mainkey={'AnalysisTasks'}
                                  mainindex={index}
                                  index={resultIndex}
                                  keyName={'Results'}
                                  Title={'AnalysisTaskResult Comments'}
                                  user={userName}
                                  Comments={
                                    formObject &&
                                      formObject['AnalysisTasks'] &&
                                      formObject['AnalysisTasks'][index] &&
                                      formObject['AnalysisTasks'][index] &&
                                      formObject['AnalysisTasks'][index]['Results'] &&
                                      formObject['AnalysisTasks'][index]['Results'][
                                      resultIndex
                                      ] &&
                                      formObject['AnalysisTasks'][index]['Results'][
                                      resultIndex
                                      ]['Comments'] &&
                                      formObject['AnalysisTasks'][index]['Results'][
                                      resultIndex
                                      ]['Comments'] !== undefined
                                      ? formObject['AnalysisTasks'][index]['Results'][
                                      resultIndex
                                      ]['Comments']
                                      : []
                                  }
                                  submitComments={SubmitComments}
                                />
                                <Form.Item
                                  labelCol={{ flex: '130px' }}
                                  label="Description"
                                  name={[
                                    'AnalysisTasks',
                                    index,
                                    'Results',
                                    resultIndex,
                                    'Description'
                                  ]}
                                  style={{ flex: '100%' }}
                                  onChange={(e) =>
                                    onResultTaskHandleChange(
                                      e.target.value,
                                      'AnalysisTasks',
                                      index,
                                      'Results',
                                      resultIndex,
                                      'Description'
                                    )
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please Provide Description'
                                    }
                                  ]}
                                >
                                  <TextArea
                                    maxLength={10000}
                                    style={{
                                      height: 100,
                                      width: '70%'
                                    }}
                                    placeholder="Input Description"
                                  />
                                </Form.Item>
                                <Form.Item
                                  name={[
                                    'AnalysisTasks',
                                    index,
                                    'Results',
                                    resultIndex,
                                    'observations'
                                  ]}
                                  labelCol={{ flex: '130px' }}
                                  label="observations"
                                  style={{ flex: '100%' }}
                                  onChange={(e) =>
                                   onResultTaskHandleChange(
                                      e.target.value,
                                      'AnalysisTasks',
                                      index,
                                      'Results',
                                      resultIndex,
                                      'observations'
                                    )
                                  }
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please Provide observations'
                                    }
                                  ]}
                                >
                                  <TextArea
                                    maxLength={10000}
                                    style={{
                                      height: 100,
                                      width: '70%'
                                    }}
                                    placeholder="Input observations"
                                  />
                                </Form.Item>
                                <Form.Item
                                  name={["AnalysisTasks", index, "Results", resultIndex, 'CreatedBy']}
                                  labelCol={{ flex: '130px' }}
                                  style={{ flex: '100%' }}
                                  label="Created By"
                                  key={resultIndex}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Value Missing'
                                    }
                                  ]}
                                >
                                  <Select
                                    disabled
                                    suffix={<UserOutlined />}
                                    
                                    value={
                                     props &&
                                     props.userProfile &&
                                     props.userProfile.user &&
                                     props.userProfile.user.Id
                                    }
                                    onChange={(e) =>
                                     onResultTaskHandleChange(
                                        e,
                                        'AnalysisTasks',
                                        index,
                                        'Results',
                                        resultIndex,
                                        'CreatedBy'
                                      )
                                    }
                                    placeholder="Select CreatedBy"
                                    style={{ width: '70%' }}
                                  >
                                    {users &&
                                      Array.isArray(users) &&
                                      users.map((item, index) => {
                                        return (
                                          <Select.Option key={index} value={item.Id}>
                                            {item.FirstName}
                                          </Select.Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  name={["AnalysisTasks", index, "Results", resultIndex, 'CreatedDate']}
                                  labelCol={{ flex: '130px' }}
                                  style={{ flex: '100%' }}
                                  label="Created Date"
                                  key={resultIndex}
                                  onChange={(e) =>
                                   onResultTaskHandleChange(
                                      e.target.value,
                                      'AnalysisTasks',
                                      index,
                                      'Results',
                                      resultIndex,
                                      'CreatedDate'
                                    )
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Value Missing'
                                    }
                                  ]}
                                >
                                  <Input
                                    value={moment().format('YYYY-MM-DD HH:mm:ss')}
                                    disabled
                                    
                                    style={{ width: '70%' }}
                                    placeholder="CreatedDate"
                                    suffix={<FieldTimeOutlined />}
                                  />
                                </Form.Item>
                                <Form.Item
                                  labelCol={{ flex: '130px' }}
                                  style={{ flex: '100%' }}
                                  label="Evaluation Metric"
                                  onChange={(e) =>
                                   onResultTaskHandleChange(
                                      e.target.value,
                                      'AnalysisTasks',
                                      index,
                                      'Results',
                                      resultIndex,
                                      'EvaluationMetric'
                                    )
                                  }
                                  name={[
                                    'AnalysisTasks',
                                    index,
                                    'Results',
                                    resultIndex,
                                    'EvaluationMetric'
                                  ]}
                                  key={resultIndex}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Value Missing'
                                    }
                                  ]}
                                >
                                  <Input
                                    style={{
                                      width: '70%'
                                    }}
                                    placeholder="Input Evaluation Metric"
                                  />
                                </Form.Item>
                                <Form.Item
                                  name={[
                                    'AnalysisTasks',
                                    index,
                                    'Results',
                                    resultIndex,
                                    'MetricValue'
                                  ]}
                                  labelCol={{ flex: '130px' }}
                                  style={{ flex: '100%' }}
                                  label="Metric Value"
                                  key={resultIndex}
                                  onChange={(e) =>
                                   onResultTaskHandleChange(
                                      e.target.value,
                                      'AnalysisTasks',
                                      index,
                                      'Results',
                                      resultIndex,
                                      'MetricValue'
                                    )
                                  }
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Value Missing'
                                    }
                                  ]}
                                >
                                  <Input
                                    style={{
                                      width: '70%'
                                    }}
                                    placeholder="Input Metric Value"
                                  />
                                </Form.Item>
                                <Form.Item
                                  name={[
                                    'AnalysisTasks',
                                    index,
                                    'Results',
                                    resultIndex,
                                    'Attachments'
                                  ]}
                                  labelCol={{ flex: '130px' }}
                                  style={{ flex: '100%' }}
                                  label="Attachments"
                                >
                                  <div>
                                    <Select
                                      
                                      style={{ width: '70%' }}
                                      placeholder={'Add/View Attachments'}
                                      onChange={(e) =>
                                       handleAnalysisResultsClick(
                                          e,
                                          index,
                                          resultIndex
                                        )
                                      }
                                    >
                                      <Select.Option
                                        key={'View Attachments'}
                                        value={'View Attachments'}
                                      >
                                        View Attachments
                                      </Select.Option>
                                      <Select.Option
                                        key={'Add New Attachments'}
                                        value={'Add New Attachments'}
                                      >
                                        Add New Attachments
                                      </Select.Option>
                                    </Select>
                                    <Upload
                                      style={{
                                        width: '90%',
                                        marginRight: '5px'
                                      }}
                                      multiple={true}
                                      onChange={(info) =>
                                       fileUpload(
                                          info,
                                          'Results',
                                          resultIndex,
                                          'AnalysisTasks',
                                          index
                                        )
                                      }
                                      action={`${ANALYTICS.FileUpload
                                        }?SiteId=${siteId}&Type=${'Results'}`}
                                      headers={{
                                        Authorization: Authorization
                                      }}
                                      showUploadList={false}
                                    >
                                      <Button
                                        style={{
                                          display: 'none'
                                        }}
                                        ref={analysisresultRef}
                                        className="uploadFile"
                                      >
                                        <UploadOutlined /> Upload
                                      </Button>
                                    </Upload>
                                    <Drawer
                                      title="AnalysisTask Results Uploaded Files"
                                      open={analysisResultsFileModalVisible}
                                      width={600}
                                      onOk={() => setAnalysisResultsFileModalVisible(false)
                                      }
                                      onClose={() => setAnalysisResultsFileModalVisible(false)
                                      }
                                    >
                                      <StyledTable size="small"
                                        className='table'
                                        columns={columns}
                                        dataSource={analysisResultsdataSource}
                                      />
                                    </Drawer>
                              </div>
                              </Form.Item>
                                <Form.Item
                                  name={'Comments'}
                                  labelCol={{ flex: '130px' }}
                                  style={{ flex: '100%' }}
                                  label="Comments"
                                >
                                  <Tooltip
                                    placement="topLeft"
                                    color={'red'}
                                    title="Click Here To Add Your Comments"
                                  >
                                    <Badge
                                      count={
                                        formObject &&
                                        formObject['AnalysisTasks'] &&
                                        formObject['AnalysisTasks'][index] &&
                                        formObject['AnalysisTasks'][index][
                                        'Results'
                                        ] &&
                                        formObject['AnalysisTasks'][index]['Results'][
                                        resultIndex
                                        ] &&
                                        formObject['AnalysisTasks'][index]['Results'][
                                        resultIndex
                                        ]['Comments'] &&
                                        formObject['AnalysisTasks'][index]['Results'][
                                          resultIndex
                                        ]['Comments'].length
                                      }
                                    >
                                      <Button
                                        style={{
                                          background: '#eabe6f',
                                          color: 'black'
                                        }}
                                        onClick={() => {
                                          let resultsCommentsData = {
                                            Comments: formObject['AnalysisTasks']?.[index]?.['Results']?.[resultIndex]?.Comments || [],
                                            index: resultIndex,
                                            mainindex: index
                                          };
                                          setCommentsData(resultsCommentsData);
                                          setRemarksModalVisible(true);
                                         
                                         
                                        }}
                                      >
                                        <CommentOutlined />
                                        Add/View Comments
                                      </Button>
                                    </Badge>
                                  </Tooltip>
                                </Form.Item>
                              </Modal>
              ) : null}
            </>
          ))}
        </div>
        ) : null}
        </>
          ))

        ) : (
  
          <div>No Analysis Tasks Available</div>
  
        )}
        </div>
      ),
        }
        ];
  const items02 = [
    {
      key: '1',
      label: 'List of Prediction',
      children: (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {predictionActivekey === '1' && predictionViewType === 'card' ? (
            formObject && formObject.Id ? (
              formObject.PredictionTasks ? (
                formObject.PredictionTasks.map((item, i) => (
                  <Card
                    key={item.title}
                    style={{
                      width: '410px',
                      padding: '5px',
                      margin: '5px',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div
                        style={{
                          padding: '0px 0px 6px 0px',
                          
                          fontWeight: 'bolder',
                          color: '#d98e04',
                        }}
                      >
                        {add3Dots(item.functionalDescription, 35)}
                      </div>
                      <div style={{ margin: '0px 0px 7px 0px' }}>
                        <IconText
                          icon={UserOutlined}
                          text={props.userProfile?.user?.FirstName}
                          key="list-vertical-star-o"
                        />
                      </div>
                      <div style={{ margin: '0px 0px 7px 0px' }}>
                        <IconText
                          icon={CalendarOutlined}
                          text={moment(item.CreatedDate).format('DD-MM-YYYY HH:mm:ss')}
                          key="list-vertical-like-o"
                        />
                      </div>
                    </div>
                    <Divider className="customDividerHor" style={{ borderTop: '1px solid #000', height: '0px' }} />
                    <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px' }}>
                      <Tooltip placement="top" key="Edit" title="Edit">
                        <EditOutlined
                          style={{ color: '#d98e04', marginRight: '8px' }}
                          onClick={() => editPredictionData(item, item.Id, i)}
                        />
                      </Tooltip>
                      <Divider type="vertical" />
                      <Popconfirm
                        key="1"
                        title="Are you sure that you want to delete the Task"
                        icon={<QuestionCircleOutlined style={{ color: '#d98e04' }} />}
                        onConfirm={() => deletePredictionTasks(item.Id, i)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Tooltip placement="top" key="Delete" title="Delete">
                          <DeleteOutlined style={{ color: '#d98e04', marginRight: '8px' }} />
                        </Tooltip>
                      </Popconfirm>
                    </div>
                  </Card>
                ))
              ) : null
            ) : null
          ) : (
            <StyledTable size="small"
              className="table"
              dataSource={formObject?.PredictionTasks ?? []}
              columns={PredictionColumns}
            />
          )}
        </div>
      ),
    },
    {
      key: '2',
      label: 'Details of Prediction',
      children: (
        <div>
          {formObject &&
              formObject.PredictionTasks &&
              formObject.PredictionTasks !== undefined &&
              formObject.PredictionTasks.length !== 0
              ? formObject.PredictionTasks.map((item, Index) =>
              predictionIndex === Index ||
              (formObject.PredictionTasks[formObject.PredictionTasks.length - 1] && addPredictionData ===true) ||
              predictionTableId === formObject.PredictionTasks[Index].Id ? (
                <>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <Form.Item
                    name={['PredictionTasks', Index, 'Title']}
                    labelCol={{ flex: '130px' }}
                    label="Title"
                    onChange={(e) => onHandleChangePrediction(e.target.value, 'PredictionTasks', Index, 'Title')}
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Provide Title' }]}
                  >
                    <Input maxLength={10000}  style={{ width: '50%' }} placeholder="Input Title" />
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'functionalDescription']}
                    labelCol={{ flex: '130px' }}
                    label="Functional Description"
                    onChange={(e) => onHandleChangePrediction(e.target.value, 'PredictionTasks', Index, 'functionalDescription')}
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Provide FunctionalDescription' }]}
                  >
                    <TextArea maxLength={10000} style={{ height: 100, width: '50%' }} placeholder="Input FunctionalDescription" />
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'relatedTags']}
                    labelCol={{ flex: '130px' }}
                    // {...restField}
                        // name={[name, 'RelatedTags']}
                    label="related Tags"
                    style={{ flex: '100%' }}
                  >
                    <Select
                      style={{ width: '50%' }}
                      
                      mode="multiple"
                      onChange={(e) => onHandleChangePrediction(e, 'PredictionTasks', Index, 'relatedTags')}
                      placeholder="Select Tags"
                    >
                      {relatedTags &&
                            Array.isArray(relatedTags) &&
                            relatedTags.map((item, index) => (
                        <Select.Option key={index} value={item.Value}>
                          {item.Key}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'CreatedBy']}
                    labelCol={{ flex: '130px' }}
                    label="CreatedBy"
                    style={{ flex: '100%' }}
                    rules={[{ required: false, message: 'Please Select CreatedBy!' }]}
                  >
                    <Select
                      disabled
                      suffix={<UserOutlined />}
                      value={props.userProfile?.user?.Id}
                      
                      onChange={(e) => onHandleChangePrediction(e, 'PredictionTasks', Index, 'CreatedBy')}
                      placeholder="Select CreatedBy"
                      style={{ width: '50%' }}
                    >
                      {users &&
                            Array.isArray(users) &&
                            users.map((item, index) => (
                        <Select.Option key={index} value={item.Id}>
                          {item.FirstName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'CreatedDate']}
                    labelCol={{ flex: '130px' }}
                    onChange={(e) =>
                      onHandleChangePrediction(
                        e.target.value,
                        'PredictionTasks',
                        Index,
                        'CreatedDate'
                      )
                    }
                    label="CreatedDate"
                    style={{ flex: '100%' }}
                    rules={[{ required: false, message: 'CreatedDate is required' }]}
                  >
                    <Input
                      value={moment().format('YYYY-MM-DD HH:mm:ss')}
                      disabled
                      
                      style={{ width: '50%' }}
                      placeholder="CreatedDate"
                      suffix={<FieldTimeOutlined />}
                    />
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'Assigne']}
                    labelCol={{ flex: '130px' }}
                    label="Assigne"
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Select Assigne!' }]}
                  >
                    <Select
                      
                      placeholder="Select Assigne"
                      onChange={(e) => onHandleChangePrediction(e, 'PredictionTasks', Index, 'Assigne')}
                      style={{ width: '50%' }}
                    >
                      {users?.map((item, index) => (
                        <Select.Option key={index} value={item.Id}>
                          {item.UserName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'Status']}
                    labelCol={{ flex: '130px' }}
                    label="Status"
                    style={{ flex: '100%' }}
                  >
                    <Select
                      
                      style={{ width: '50%' }}
                      onChange={(e) => onHandleChangePrediction(e, 'PredictionTasks', Index, 'Status')}
                      placeholder="Select Status"
                    >
                      {statusList &&
                            Array.isArray(statusList) &&
                            statusList.map((item, index) => (
                        <Select.Option key={index} value={item.Value}>
                          {item.Key}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'Date']}
                    labelCol={{ flex: '130px' }}
                    label="From And To Date"
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Provide Date' }]}
                  >
                    <RangePicker
                      value={
                        formObject &&
                              formObject.PredictionTasks &&
                              formObject.PredictionTasks[Index] &&
                              formObject.PredictionTasks[Index].Date &&
                              formObject.PredictionTasks[Index].Date !== null
                              ? [
                              moment(formObject.PredictionTasks[Index].Date[0], 'YYYY-MM-DD HH:mm'),
                              moment(formObject.PredictionTasks[Index].Date[1], 'YYYY-MM-DD HH:mm'),
                            ]
                          : []
                      }
                      onChange={(e) => onHandleChangePrediction(e, 'PredictionTasks', Index, 'Date')}
                      disabledDate={(e) => disabledDate(e)}
                      style={{ width: '50%' }}
                      showTime={{ format: 'HH:mm' }}
                      format="YYYY-MM-DD HH:mm"
                    />
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'Approach']}
                    labelCol={{ flex: '130px' }}
                    label="Approach"
                    onChange={(e) => onHandleChangePrediction(e.target.value, 'PredictionTasks', Index, 'Approach')}
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Provide Approach' }]}
                  >
                    <Input maxLength={10000}  style={{ width: '50%' }} placeholder="Input Approach" />
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'Algorithms']}
                    labelCol={{ flex: '130px' }}
                    onChange={(e) => onHandleChangePrediction(e.target.value, 'PredictionTasks', Index, 'Algorithms')}
                    label="Algorithms"
                    style={{ flex: '100%' }}
                    rules={[{ required: true, message: 'Please Provide Algorithms' }]}
                  >
                    <Input maxLength={10000}  style={{ width: '50%' }} placeholder="Input Algorithms" />
                  </Form.Item>
                  <Form.Item
                    labelCol={{ flex: '130px' }}
                    style={{ flex: '100%' }}
                    name={['PredictionTasks', Index, 'Attachments']}
                    label="Attachments"
                  >
                    <div>
                      <Select
                        
                        style={{ width: '50%' }}
                        placeholder={'Add/View Attachments'}
                        onChange={(e) => handlePredictionTasksClick(e, Index)}
                      >
                        <Select.Option key={'View Attachments'} value={'View Attachments'}>
                          View Attachments
                        </Select.Option>
                        <Select.Option key={'Add New Attachments'} value={'Add New Attachments'}>
                          Add New Attachments
                        </Select.Option>
                      </Select>
                      <Upload
                        multiple={true}
                        onChange={(info) => fileUpload(info, 'PredictionTasks', Index)}
                        action={`${ANALYTICS.FileUpload}?SiteId=${siteId}&Type=${'Task'}`}
                        headers={{ Authorization : Authorization}}
                        showUploadList={false}
                      >
                        <Button style={{ display: 'none' }} ref={predictionRef} className="uploadFile">
                          <UploadOutlined /> Upload
                        </Button>
                      </Upload>
                      <Drawer
                        title="PredictionTask Uploaded Files"
                        className="PredictionTaskUploadedFiles"
                        open={predictionfileModalVisible}
                        width={600}
                        onOk={() => setPredictionFileModalVisible(false)}
                        onClose={() => setPredictionFileModalVisible(false)}
                      >
                        <StyledTable size="small" columns={columns} dataSource={predictiondataSource} />
                      </Drawer>
                    </div>
                  </Form.Item>
                  <Form.Item
                    name={['PredictionTasks', Index, 'Comments']}
                    labelCol={{ flex: '130px' }}
                    style={{ flex: '100%' }}
                    label="Comments"
                  >
                    <Tooltip placement="topLeft" color={'red'} title="Click Here To Add Your Comments">
                      <Badge
                        count={
                          formObject['PredictionTasks'] &&
                          formObject['PredictionTasks'][Index] &&
                          formObject['PredictionTasks'][Index]['Comments'] &&
                          formObject['PredictionTasks'][Index]['Comments'].length
                        }
                      >
                        <Button
                          style={{ background: '#eabe6f', color: 'black' }}
                          onClick={() => {
                            let commentsData = {
                              Comments:
                              formObject &&
                              formObject['PredictionTasks'] &&
                              formObject['PredictionTasks'][Index] &&
                              formObject['PredictionTasks'][Index]['Comments']
                              ? [
                                ...formObject['PredictionTasks'][Index][
                                'Comments'
                                ]
                              ]
                              : [],
                          index: Index
                            };
                            setCommentsData(commentsData);
                            setPredictionTaskModalVisible(true);
                          }}
                        >
                          <CommentOutlined />
                          Add/View Comments
                        </Button>
                      </Badge>
                    </Tooltip>
                  </Form.Item>
                  <Button
                    style={{ background: '#29415a', color: '#fff' }}
                    onClick={() => addPredictionResults(Index)}
                  >
                    <PlusOutlined /> Add Results
                  </Button>
                  <div style={{ marginTop: '60px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                      {formObject &&
                            formObject.PredictionTasks &&
                            formObject.PredictionTasks[Index] &&
                            formObject.PredictionTasks[Index].Results &&
                            predictionResult === true
                            ? formObject.PredictionTasks[Index].Results.map((predicResultKey, ind) => (
                        <Card
                          key={predicResultKey.title}
                          style={{
                            width: '410px',
                            padding: '5px',
                            margin: '5px',
                          }}
                        >
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div
                              style={{
                                padding: '0px 0px 6px 0px',
                                
                                fontWeight: 'bolder',
                                color: '#d98e04',
                              }}
                            >
                              {add3Dots(predicResultKey.Description, 35)}
                            </div>
                            <div style={{ margin: '0px 0px 7px 0px' }}>
                              <IconText
                                icon={UserOutlined}
                                text={props.userProfile?.user?.FirstName}
                                key="list-vertical-star-o"
                              />
                            </div>
                            <div style={{ margin: '0px 0px 7px 0px' }}>
                              <IconText
                                icon={CalendarOutlined}
                                text={moment(predicResultKey.CreatedDate).format('DD-MM-YYYY HH:mm:ss')}
                                key="list-vertical-like-o"
                              />
                            </div>
                          </div>
                          <Divider className="customDividerHor" style={{ borderTop: '1px solid #000', height: '0px' }} />
                          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px' }}>
                            <Tooltip placement="top" key="Edit" title="Edit">
                              <EditOutlined
                                style={{ color: '#d98e04', marginRight: '8px' }}
                                onClick={() => editAnalyticResult(predicResultKey, predicResultKey.Id, ind, 'PredictionTasks')}
                              />
                            </Tooltip>
                            <Divider type="vertical" />
                            <Popconfirm
                              key="1"
                              title="Are you sure that you want to delete the Result"
                              icon={<QuestionCircleOutlined style={{ color: '#d98e04' }} />}
                              onConfirm={() => deleteResultTasks('PredictionTasks', Index, 'Results', ind)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Tooltip placement="top" key="Delete" title="Delete">
                                <DeleteOutlined style={{ color: '#d98e04', marginRight: '8px' }} />
                              </Tooltip>
                            </Popconfirm>
                          </div>
                        </Card>
                      )): null}
                    </div>
                  </div>
                  {formObject &&
                        formObject.PredictionTasks &&
                        formObject.PredictionTasks[Index] &&
                        formObject.PredictionTasks[Index].Results &&
                        formObject.PredictionTasks[Index].Results.length !== 0 &&
                        formObject.PredictionTasks[Index].Results !== undefined &&
                        formObject.PredictionTasks[Index].Results.map((PrectictionKe, resultIndex1) => (
                          <>
                   { predictionResultInd === resultIndex1 || addNewPredictionResult === true ? (
                      <Modal
                        title="Add Result"
                        className="AddResultDrawer"
                        open={isPredictionResultVisible}
                        onOk={handleOkPrediction}
                        onCancel={handleCancelPrediction}
                      >
                        <CommentsForm
                          visible={remarksModalVisible}
                          modalClose={resultsModalClose}
                          mainkey={'PredictionTasks'}
                          Title={'PredictionTaskResult Comments'}
                          mainindex={Index}
                          index={resultIndex1}
                          keyName={'Results'}
                          user={userName}
                          Comments={formObject['PredictionTasks']?.[Index]?.Results?.[resultIndex1]?.Comments || []}
                          submitComments={SubmitComments}
                        />
                        <Form.Item
                          name={['PredictionTasks', Index, 'Results', resultIndex1, 'Description']}
                          labelCol={{ flex: '130px' }}
                          label="Description"
                          style={{ flex: '100%' }}
                          onChange={(e) => onResultTaskHandleChange(e.target.value, 'PredictionTasks', Index, 'Results', resultIndex1, 'Description')}
                          rules={[{ required: true, message: 'Please Provide Description' }]}
                        >
                          <TextArea maxLength={10000} style={{ width: '70%', height: 100 }} placeholder="Input Description" />
                        </Form.Item>
                        <Form.Item
                          name={['PredictionTasks', Index, 'Results', resultIndex1, 'observations']}
                          labelCol={{ flex: '130px' }}
                          label="Observations"
                          style={{ flex: '100%' }}
                          onChange={(e) => onResultTaskHandleChange(e.target.value, 'PredictionTasks', Index, 'Results', resultIndex1, 'observations')}
                          rules={[{ required: false, message: 'Please Provide observations' }]}
                        >
                          <TextArea maxLength={10000} style={{ width: '70%', height: 100 }} placeholder="Input observations" />
                        </Form.Item>
                        <Form.Item
                          labelCol={{ flex: '130px' }}
                          style={{ flex: '70%' }}
                          label="CreatedBy"
                          rules={[{ required: true, message: 'Value Missing' }]}
                        >
                          <Select
                            disabled
                            
                            placeholder="Select CreatedBy"
                            value={props.userProfile?.user?.Id}
                            onChange={(e) => onResultTaskHandleChange(e, 'PredictionTasks', Index, 'Results', resultIndex1, 'CreatedBy')}
                            style={{ width: '70%' }}
                          >
                            {users?.map((item) => (
                              <Select.Option key={item.Id} value={item.Id}>
                                {item.FirstName}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          name={['PredictionTasks', Index, 'Results', resultIndex1, 'CreatedDate']}
                          labelCol={{ flex: '130px' }}
                          style={{ flex: '70%' }}
                          label="CreatedDate"
                          onChange={(e) => onResultTaskHandleChange(e.target.value, 'PredictionTasks', Index, 'Results', resultIndex1, 'CreatedDate')}
                          rules={[{ required: true, message: 'Value Missing' }]}
                        >
                          <Input
                            disabled
                            value={moment().format('YYYY-MM-DD HH:mm:ss')}
                            
                            style={{ width: '70%' }}
                            placeholder="CreatedDate"
                            suffix={<FieldTimeOutlined />}
                          />
                        </Form.Item>
                        <Form.Item
                          name={['PredictionTasks', Index, 'Results', resultIndex1, 'EvaluationMetric']}
                          labelCol={{ flex: '130px' }}
                          label="Evaluation Metric"
                          onChange={(e) => onResultTaskHandleChange(e.target.value, 'PredictionTasks', Index, 'Results', resultIndex1, 'EvaluationMetric')}
                          rules={[{ required: false, message: 'Value Missing' }]}
                        >
                          <Input style={{ width: '70%' }} placeholder="Input Evaluation Metric" />
                        </Form.Item>
                        <Form.Item
                          name={['PredictionTasks', Index, 'Results', resultIndex1, 'MetricValue']}
                          labelCol={{ flex: '130px' }}
                          label="Metric Value"
                          onChange={(e) => onResultTaskHandleChange(e.target.value, 'PredictionTasks', Index, 'Results', resultIndex1, 'MetricValue')}
                          rules={[{ required: false, message: 'Value Missing' }]}
                        >
                          <Input style={{ width: '70%' }} placeholder="Input Metric Value" />
                        </Form.Item>
                        <Form.Item
                          name={['PredictionTasks', Index, 'Results', resultIndex1, 'Attachments']}
                          labelCol={{ flex: '130px' }}
                          label="Attachments"
                        >
                          <div>
                            <Select
                              
                              style={{ width: '70%' }}
                              placeholder={'Add/View Attachments'}
                              onChange={(e) => handlePredictionResultsClick(e, Index, resultIndex1)}
                            >
                              <Select.Option key={'View Attachments'} value={'View Attachments'}>
                                View Attachments
                              </Select.Option>
                              <Select.Option key={'Add New Attachments'} value={'Add New Attachments'}>
                                Add New Attachments
                              </Select.Option>
                            </Select>
                            <Upload
                              style={{ width: '90%', marginRight: '5px' }}
                              multiple={true}
                              onChange={(info) => fileUpload(info, 'Results', resultIndex1, 'PredictionTasks', Index)}
                              action={`${ANALYTICS.FileUpload}?SiteId=${siteId}&Type=${'Results'}`}
                              headers={{ Authorization }}
                              showUploadList={false}
                            >
                              <Button style={{ display: 'none' }} ref={predictionResultRef} className="uploadFile">
                                <UploadOutlined /> Upload
                              </Button>
                            </Upload>
                            <Drawer
                              title="PredictionTask Results Uploaded Files"
                              className="PredictionTaskResultsUploadedFiles"
                              open={predictionResultsFileModalVisible}
                              width={600}
                              onOk={() => setPredictionResultsFileModalVisible(false)}
                              onClose={() => setPredictionResultsFileModalVisible(false)}
                            >
                              <StyledTable size="small" columns={columns} dataSource={predictionResultsdataSource} />
                            </Drawer>
                          </div>
                        </Form.Item>
                        <Form.Item
                          name={'Comments'}
                          labelCol={{ flex: '130px' }}
                          style={{ flex: '70%' }}
                          label="Comments"
                        >
                          <Tooltip placement="topLeft" color={'red'} title="Click Here To Add Your Comments">
                            <Badge
                              count={
                                formObject['PredictionTasks']?.[Index]?.Results?.[resultIndex1]?.Comments?.length
                              }
                            >
                              <Button
                                style={{ background: '#eabe6f', color: 'black' }}
                                onClick={() => {
                                  let resultsCommentsData = {
                                    Comments: formObject['PredictionTasks']?.[Index]?.Results?.[resultIndex1]?.Comments || [],
                                    index: resultIndex1,
                                    mainindex: Index,
                                  };
                                 setCommentsData(resultsCommentsData);
                                  setRemarksModalVisible(true);
                                }}
                              >
                                <CommentOutlined />
                                Add/View Comments
                              </Button>
                            </Badge>
                          </Tooltip>
                        </Form.Item>
                      </Modal>
                    ) : null}
                    </>
                  )
                  )}
                </div>
                </>
              ) : null
          ) : null}
        </div>),
    }
  ];
  return (
    <>
      <div
        className="PredictionForm"
        style={{
          minHeight: '700px',
          marginTop: '30px',
          marginBottom: '30px',
          color: 'black',
          fontWeight: 'bold',
        }}
      >
        <Form
          name="TaskData"
          className="collapse"
          ref={formHeader}
          initialValues={formObject}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="horizontal"
          labelCol={{ flex: '130px' }}
          labelAlign="right"
          labelWrap
          wrapperCol={{ flex: 1 }}
        >
          <Form.Item style={{ display: 'none' }}></Form.Item>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              label="Title"
              name={'Title'}
              style={{ width: '100%', flex: '50%' }}
              rules={[{ required: true, message: 'Please Provide Title' }]}
            >
              <Input
                style={{ width: '70%' }}
                maxLength={10000}
                
                placeholder="Input Title"
              />
            </Form.Item>
            <Form.Item
              label="Related Tags"
              name="RelatedTags"
              style={{ width: '100%', flex: '50%' }}
            >
              <Select mode="multiple" placeholder="Select Tags" style={{ width: '70%' }}>
                {relatedTags &&
                  Array.isArray(relatedTags) &&
                  relatedTags.map((item, index) => (
                    <Select.Option key={index} value={item.Value}>
                      {item.Key}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label="Created By"
              name={'CreatedBy'}
            >
              <Select
                disabled
                suffix={<UserOutlined />}
                
                placeholder="Select CreatedBy"
                style={{ width: '70%', background: 'white' }}
              >
                {users &&
                  Array.isArray(users) &&
                  users.map((item, index) => (
                    <Select.Option key={index} value={item.Id}>
                      {item.FirstName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%', color: 'black' }}
              label="Created Date"
              name={'CreatedDate'}
            >
              <Input
                disabled
                
                style={{ width: '70%', background: 'white' }}
                placeholder="CreatedDate"
                suffix={<FieldTimeOutlined />}
              />
            </Form.Item>
            <Form.Item
              label="Usecase"
              name={'Usecase'}
              style={{ width: '100%' }}
              rules={[{ required: true, message: 'Please Provide Usecase' }]}
            >
              <TextArea
                style={{
                  height: 100,
                  width: '86%',
                }}
                maxLength={10000}
                placeholder="Input Usecase"
              />
            </Form.Item>
            <Form.Item
              label="Functional Description"
              name={'functionalDescription'}
              style={{ width: '100%' }}
              rules={[
                {
                  required: true,
                  message: 'Please Provide FunctionalDescription',
                },
              ]}
            >
              <TextArea
                maxLength={10000}
                style={{
                  height: 100,
                  width: '86%',
                }}
                placeholder="Input FunctionalDescription"
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label="Attachments"
            >
              <Select
                
                style={{ width: '70%' }}
                placeholder={'Add/View Attachments'}
                onChange={(e) => handleClick(e)}
              >
                <Select.Option key={'View Attachments'} value={'View Attachments'}>
                  View Attachments
                </Select.Option>
                <Select.Option key={'Add New Attachments'} value={'Add New Attachments'}>
                  Add New Attachments
                </Select.Option>
              </Select>
              <Upload
                multiple={true}
                onChange={(info) => fileUpload(info)}
                action={`${ANALYTICS.FileUpload}?SiteId=${siteId}&Type=${'UseCase'}`}
                headers={{
                  Authorization :Authorization,
                }}
                showUploadList={false}
              >
                <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                  <UploadOutlined /> Upload
                </Button>
              </Upload>
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label="Comments"
            >
              <Tooltip
                placement="topLeft"
                color={'red'}
                title="Click Here To Add Your Comments"
              >
                <Badge
                  count={formObject && formObject['Comments'] && formObject['Comments'].length}
                >
                  <Button
                    style={{ background: '#eabe6f', color: 'black' }}
                    onClick={() => setUseCaseModalVisible(true)}
                  >
                    <CommentOutlined />
                    Add/View Comments
                  </Button>
                </Badge>
              </Tooltip>
            </Form.Item>
            {useCaseModalVisible && (
              <CommentsForm
                Comments={
                  formObject && formObject['Comments'] ? [...formObject['Comments']] : []
                }
                Title={'UseCase Comments'}
                visible={useCaseModalVisible}
                modalClose={useCaseModalClose}
                user={userName}
                submitComments={SubmitComments}
              />
            )}
          </div>
          <Drawer
            title="UseCase Uploaded Files"
            open={showusecasedownloadModal}
            width={600}
            onOk={() => setShowUseCaseDownloadModal(false)}
            onClose={() => setShowUseCaseDownloadModal(false)}
          >
            <StyledTable size="small"
              className="table"
              columns={columns}
              dataSource={
                formObject &&
                formObject.Attachments &&
                Array.isArray(formObject.Attachments) &&
                formObject.Attachments
                  ? [...formObject.Attachments]
                  : []
              }
            />
          </Drawer>
          <Radio.Group
            style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              color: 'white !important',
            }}
            value={selectedTask}
            buttonStyle="solid"
            onChange={(e) => {setSelectedTask(e.target.value);
              // setFormObject(formObject);
            }}
          >
            <Radio value="Analysis Tasks">
              Analysis Tasks
            </Radio>
            <Radio value="Prediction Tasks" // onChange={(e) => this.onPrediction(e)}
            >
              Prediction Tasks
            </Radio>
          </Radio.Group>
          {selectedTask === 'Analysis Tasks' ? (
            <div style={{ background: 'rgb(26, 59, 92)', padding: '20px' }}>
              {analysisTaskModalVisible && (
                <CommentsForm
                  visible={analysisTaskModalVisible}
                  modalClose={analysisTaskModalClose}
                  keyName={'AnalysisTasks'}
                  Title={'AnalysisTask Comments'}
                  {...{ ...commentsData }}
                  user={userName}
                  formObject={
                    formHeader.current && formHeader.current.getFieldsValue()
                      ? formHeader.current.getFieldsValue()
                      : {}
                  }
                  submitComments={SubmitComments}
                />
              )}
              <div style={{ float: 'right' }}>
                {activeKey === '1' && (
                  <PlusOutlined
                    onClick={addAnalytics}
                    style={{
                      
                      color: viewType === 'table' ? 'rgb(255, 108, 0)' : '#dfa230',
                      marginLeft: '10px',
                    }}
                  />
                )}
                <UnorderedListOutlined
                  onClick={() => onViewTypeChange(selectedTask, 'table')}
                  style={{
                    
                    color: viewType === 'table' ? 'rgb(255, 108, 0)' : '#dfa230',
                    marginLeft: '10px',
                  }}
                />
                <AppstoreOutlined
                  onClick={() => onViewTypeChange(selectedTask, 'card')}
                  style={{
                    
                    color: viewType === 'card' ? 'rgb(255, 108, 0)' : '#dfa230',
                    marginLeft: '10px',
                  }}
                />
              </div>
              <Tabs
                defaultActiveKey="1"
                type="card"
                activeKey={activeKey}
                onChange={(activeKey) => setActiveKey(activeKey)}
                items={items01}
              />
            </div>
          ) : (
            <div style={{ background: 'rgb(26, 59, 92)', padding: '20px' }}>
              {predictionTaskModalVisible && (
                <CommentsForm
                  visible={predictionTaskModalVisible}
                  modalClose={predictionTaskModalClose}
                  keyName={'PredictionTasks'}
                  Title={'PredictionTask Comments'}
                  {...{ ...commentsData }}
                  user={userName}
                  formObject={
                    formHeader.current && formHeader.current.getFieldsValue()
                      ? formHeader.current.getFieldsValue()
                      : {}
                  }
                  submitComments={SubmitComments}
                />
              )}
              <div style={{ float: 'right' }}>
                {predictionActivekey === '1' && (
                  <PlusOutlined
                    onClick={addPredictions}
                    style={{
                      
                      color: viewType === 'table' ? 'rgb(255, 108, 0)' : '#dfa230',
                      marginLeft: '10px',
                    }}
                  />
                )}
                <UnorderedListOutlined
                  onClick={() => onViewTypeChange(selectedTask, 'table')}
                  style={{
                    
                    color: predictionViewType === 'table' ? 'rgb(255, 108, 0)' : '#dfa230',
                    marginLeft: '10px',
                  }}
                />
                <AppstoreOutlined
                  onClick={() => onViewTypeChange(selectedTask, 'card')}
                  style={{
                    
                    color: predictionViewType === 'card' ? 'rgb(255, 108, 0)' : '#dfa230',
                    marginLeft: '10px',
                  }}
                />
              </div>
              <Tabs
                defaultActiveKey="1"
                type="card"
                activeKey={predictionActivekey}
                onChange={(predictionActivekey) => setPredictionActiveKey(predictionActivekey)}
                items={items02}
              />
            </div>
          )}
          <Form.Item>
            <Button type="primary" className="SubmitButton" htmlType="submit">
              {formObject && formObject.Id ? 'Update' : 'Submit'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile
});
export default connect(mapStateToProps)(PredictionForm);
